<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form">
          <a-row>
            <a-col :span="12">
              <a-form-item label="合同号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input disabled v-decorator="['contract_number', {rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="电汇付款" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-radio-group v-decorator="['is_total_pay', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                  <a-radio :value="0">部分电汇</a-radio>
                  <a-radio :value="1">全部电汇</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="付款金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" @change="amountChange"/>
                <a-select
                  style="width: 50%"
                  v-decorator="[
                    'currency',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.currency">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="购汇汇率" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['purchase_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]" @change="purchaseRateChange"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="实付人民币金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['amount_cny', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="款项性质" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  v-decorator="[
                    'method',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption2"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.method">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="支付时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-date-picker
                  style="width:100%"
                  v-decorator="['pay_time', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD HH:mm:ss"
                  show-time
                  placeholder="请选择时间"
                  @ok="payTimeOK"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-textarea :rows="1" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="备注"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item v-bind="buttonCol">
            <a-row>
              <a-col offset="6" span="6">
                <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
              </a-col>
              <a-col span="10">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { payment_list, payment_update } from '@/api/trade_payment'

const fields = ['id', 'contract_number', 'is_total_pay', 'amount', 'purchase_rate', 'currency', 'amount_cny', 'method', 'pay_time', 'remark']

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      currency: this.$Dictionaries.currency,
      method: this.$Dictionaries.trade_payment_nature,
      data: {},
      loading: false,
      purchaseRate: 0,
      amount: 0
    }
  },
  created () {
    fields.forEach(v => this.form.getFieldDecorator(v))
  },
  mounted () {
    this.loadPaymentData()
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadPaymentData () {
      this.loading = true
      payment_list({ id: this.$route.params.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.data.method = '' + this.data.method
            this.id = this.data.id
            this.purchaseRate = this.data.purchase_rate
            this.amount = this.data.amount
            this.data.is_total_pay = this.data.is_total_pay ? 1 : 0
            this.loadEditInfo(this.data)
          }
        }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          this.loading = true
          payment_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        console.log('formData', formData)
        this.id = formData.id
        form.setFieldsValue(formData)
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    filterOption2 (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    payTimeOK (value) {
      console.log(value.format('YYYY-MM-DD HH:mm:ss'))
    },
    purchaseRateChange (value) {
      this.purchaseRate = value
      const result = (this.purchaseRate * this.amount).toFixed(4)
      console.log(result)
      this.form.setFieldsValue({
        amount_cny: result
      })
    },
    amountChange (value) {
      this.amount = value
      const result = (this.purchaseRate * this.amount).toFixed(4)
      console.log(result)
      this.form.setFieldsValue({
        amount_cny: result
      })
    }
  }
}
</script>
